
import React from 'react';
// import Handson from "./Handson";
import About from "./MiniAbout";
import { styled } from '@mui/material';


    const SectionContainerStyle = styled('div')`
        margin-bottom: 40px;
        // margin-left: 20%;
        // margin-right: 20%;
    `;

    const HomePage =()=>{
        return(
            <>

                <SectionContainerStyle>
                        <About/>
                    </SectionContainerStyle>

                    {/* <SectionContainerStyle>
                        <DeployedProjects/>
                    </SectionContainerStyle> */}

                    {/* <SectionContainerStyle>
                        <Misc/>
                    </SectionContainerStyle> */}

                    {/* <SectionContainerStyle>
                        <Handson/>
                    </SectionContainerStyle> */}



            </>
        )
    }

export default HomePage;